export default __webpack_public_path__ + "static/media/centos-icon.c5283bf0.svg";